import React from 'react';
import { observer } from 'mobx-react';

import ContentHeader from 'components/drill-down-layout/components/content/components/content-header';
import PatientDataCapturedManipulation from './patient-data-captured-manipulation';

import PatientIcon from 'assets/icons/patient.svg';

import './patient-icon.scss';


const PatientsContentHeader = ({
  patientsIncompleteInfoRouteStore,
  isReady,
  markActivePatientAsCaptured,
  requestActivePatientDataCapture,
}) => {
  if (!isReady) return null;

  const { activePatient } = patientsIncompleteInfoRouteStore;

  return <ContentHeader
    title={activePatient && `${activePatient.firstName} ${activePatient.lastName}`}
    leftLabel={
      <img
        alt='Patient'
        src={PatientIcon}
        className='patient-icon-preview-large'
      />
    }
    subHeader={<PatientDataCapturedManipulation
      activePatient={activePatient}
      markActivePatientAsCaptured={markActivePatientAsCaptured}
      requestActivePatientDataCapture={requestActivePatientDataCapture}
    />}
  />;
};

export default observer(PatientsContentHeader);
